module.exports = __webpack_public_path__ + "static/media/400140_01.e567db26.png";